import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

export const LoginPage: React.FC = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    // Try redirect method instead of popup for better compatibility
    instance.loginRedirect(loginRequest).catch(e => {
      console.error('Login failed:', e);
    });
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>SM4RT</h1>
        <p>Secure Module For Responsive Ticketing</p>
        <button onClick={handleLogin} className="login-button">
          Sign in with Microsoft 365
        </button>
      </div>
    </div>
  );
};